// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__LhAkr","itemTitle":"ClientEmergencyInfo_itemTitle__172q6","itemText":"ClientEmergencyInfo_itemText__3BfBg"};